import { ActionTree } from 'vuex';
import { TrackingState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { CheckoutAction } from './actions/checkout.action';
import { ExtraEventCallbacksAction } from './actions/extra-event-callbacks.action';
import { LoadResultIdAction } from './actions/load-result-id.action';
import { MoveResultToSessionStorageAction } from './actions/move-result-to-session-storage.action';
import { SaveItemToLocalStorageWithUrlAction } from './actions/save-item-to-local-storage-with-url.action';
import { SaveResultIdToLocalStorageAction } from './actions/save-result-id-to-local-storage.action';
import { SaveResultToLocalStorageAction } from './actions/save-result-to-local-storage.action';
import { TaggingAction } from './actions/tagging.action';
import { TrackPendingUrlClickAction } from './actions/track-pending-url-click.action';

export const TRACKING_ACTIONS: ActionTree<TrackingState, RootStoreState> = {
  ...new LoadResultIdAction().actions,
  ...new MoveResultToSessionStorageAction().actions,
  ...new SaveItemToLocalStorageWithUrlAction().actions,
  ...new SaveResultIdToLocalStorageAction().actions,
  ...new SaveResultToLocalStorageAction().actions,
  ...new TrackPendingUrlClickAction().actions,
  ...new TaggingAction().actions,
  ...new ExtraEventCallbacksAction().actions,
  ...new CheckoutAction().actions
};
